<template>
  <form class="user-form login-form">
    <span
      style="
        font-size: 14px;
        margin-bottom: 20px;
        display: block;
        color: #9293ba;
      "
      v-cyr2lat="lang"
      >{{ $t("confirmation_code_sent", { phone }) }}
    </span>
    <input
      type="text"
      v-maska="'####'"
      :class="{ invalid: !$v.code.required && $v.code.$dirty }"
      v-model="code"
      class="user-input"
      :placeholder="$t('enter_code_placeholder')"
      required
    />
    <div class="error" v-if="!$v.code.required && $v.code.$dirty">
      {{ $t("enter_confirmation_code") }}
    </div>
    <router-link
      style="
        font-size: 14px;
        margin-bottom: 20px;
        display: block;
        color: #9293ba;
        text-decoration: underline;
      "
      to="/login"
      v-cyr2lat="lang"
      >{{ $t("enter_another_number") }}</router-link
    >
    <div class="user-button">
      <label class="user-form-sub" @click.prevent="submitActivate">
        <input type="submit" /><span>{{ $t("confirm") }}</span>
        <i class="fa-out"></i>
      </label>
    </div>
  </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      code: false,
    };
  },
  validations: {
    code: {
      required,
    },
  },
  mounted() {
    if (!this.phone) {
      this.$router.push("/login");
    }
  },
  methods: {
    async submitActivate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      const user = {
        phone: this.phone,
        sms: this.code,
      };
      try {
        await this.$store.dispatch("forgotCode", user);
        await this.$router.push("/new-password");
      } catch (e) {
        console.log(e);
      }
    },
  },
  computed: {
    phone() {
      return this.$store.getters.getTelNumber;
    },
    lang() {
      return this.$store.getters.lang;
    },
  },
};
</script>
